import { useMemo } from 'react';

import { useMenuContext } from 'applications/GSP/pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';

export const useIsFavorite = () => {
  const { chatTopics } = useParentHelperContext();
  const { anchorEl } = useMenuContext();

  return useMemo(
    () => chatTopics.find(chat => chat.chatId === anchorEl?.id)?.isFavorite,
    [anchorEl?.id, chatTopics],
  );
};
